import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Context from "./context";
import { store } from "./app/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'leaflet/dist/leaflet.css'

// Syncfusion License
import { registerLicense } from '@syncfusion/ej2-base';

// Register your Syncfusion license key here
registerLicense('Ngo9BigBOggjHTQxAR8/V1JGaF1cXmhNYVJ0WmFZfVhgcV9CaVZSRmYuP1ZhSXxVdkZiWn9bdXFQQmRYVEB9XEA=');

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Context subPages={<App />} />
    </BrowserRouter>
  </Provider>
);

// Performance measurement
reportWebVitals();